/**
 * Button component
 * @returns <Button />
 */
import { Link } from "react-router-dom";

const Button = (props) => {
    const { tag, text, url, target, size, btnStyle, color, extraClass, type, hasIcon, onClick, totalPrice, currency, disabled } = props;

    if (tag === "button") {
        return (
            <button type={type ? type : "button"} className={`btn-${size ? size : "large"} btn-${btnStyle ? btnStyle : "primary"}-${color ? color : "black"} ${extraClass ? extraClass : ""} ${hasIcon ? "with-icon" : ""} ${disabled ? "--disabled" : ""}`} onClick={onClick ? onClick : null}>
                {text}

                {hasIcon && (
                    <svg width="13" height="9" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.99992 0.333313L8.05992 1.27331L11.1133 4.33331H0.333252V5.66665H11.1133L8.05325 8.72665L8.99992 9.66665L13.6666 4.99998L8.99992 0.333313Z" fill={color === "white" ? "black" : "white"} />
                    </svg>
                )}
            </button>
        )
    } else if (tag === "button-link") {
        return (
            <Link type={type ? type : "button"} className={`btn-${size ? size : "large"} btn-${btnStyle ? btnStyle : "primary"}-${color ? color : "black"} ${extraClass ? extraClass : ""} ${hasIcon ? "with-icon" : ""}`} onClick={onClick ? onClick : null} to={`${url ? url : "#"}`}>
                {text}

                {hasIcon && (
                    <svg width="13" height="9" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.99992 0.333313L8.05992 1.27331L11.1133 4.33331H0.333252V5.66665H11.1133L8.05325 8.72665L8.99992 9.66665L13.6666 4.99998L8.99992 0.333313Z" fill={color === "white" ? "black" : "white"} />
                    </svg>
                )}
            </Link>
        )
    } else if (tag === "link") {
        return (
            <Link className={`text-link primary-link-${color ? color : "black"} ${extraClass ? extraClass : ""} ${hasIcon ? "with-icon" : ""}`} to={`${url ? url : "#"}`} target={`${target ? target : "_self"}`} onClick={onClick ? onClick : null}>
                {text}

                {hasIcon && (
                    <svg width="13" height="9" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.99992 0.333313L8.05992 1.27331L11.1133 4.33331H0.333252V5.66665H11.1133L8.05325 8.72665L8.99992 9.66665L13.6666 4.99998L8.99992 0.333313Z" fill="black" />
                    </svg>
                )}
            </Link>
        )
    } else if (tag === "cart") {
        return (
            <button type={type ? type : "button"} className={`btn-${size ? size : "large"} btn-${btnStyle ? btnStyle : "primary"}-${color ? color : "black"} ${extraClass ? extraClass : ""} btn-cart with-icon ${disabled ? "--disabled" : ""}`} onClick={onClick ? onClick : null}>
                <div className="btn-cart__container">
                    {/* <span className="btn-cart__label">
                        {text}
                    </span> */}
                    <span className="btn-cart__label">{text}</span>
                    <span className="btn-cart__total">{currency === "USD" ? "U$S" : "$"}{totalPrice}</span>

                    <svg className="btn-cart__icon" width="13" height="9" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.99992 0.333313L8.05992 1.27331L11.1133 4.33331H0.333252V5.66665H11.1133L8.05325 8.72665L8.99992 9.66665L13.6666 4.99998L8.99992 0.333313Z" fill={color === "white" ? "black" : "white"} />
                    </svg>
                </div>
            </button>
        )
    } else if (tag === "cart-with-total-1-line") {
        return (
            <button type={type ? type : "button"} className={`btn-${size ? size : "large"} btn-${btnStyle ? btnStyle : "primary"}-${color ? color : "black"} ${extraClass ? extraClass : ""} btn-cart__with-total --1-line with-icon ${disabled ? "--disabled" : ""}`} onClick={onClick ? onClick : null} disabled={disabled}>
                <div className="btn-cart__container">
                    <span className="btn-cart__label-container">
                        <p className="btn-cart__label">{text}</p>
                        <p className="btn-cart__total">{currency === "USD" ? "U$S" : "$"}{totalPrice}</p>
                    </span>

                    <svg className="btn-cart__icon" width="13" height="9" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.99992 0.333313L8.05992 1.27331L11.1133 4.33331H0.333252V5.66665H11.1133L8.05325 8.72665L8.99992 9.66665L13.6666 4.99998L8.99992 0.333313Z" fill={color === "white" ? "black" : "white"} />
                    </svg>
                </div>
            </button>
        )
    } else if (tag === "cart-with-total") {
        return (
            <button type={type ? type : "button"} className={`btn-${size ? size : "large"} btn-${btnStyle ? btnStyle : "primary"}-${color ? color : "black"} ${extraClass ? extraClass : ""} btn-cart btn-cart__with-total with-icon ${disabled ? "--disabled" : ""}`} onClick={onClick ? onClick : null}>
                <div className="btn-cart__container">
                    <span className="btn-cart__label-container">
                        <p className="btn-cart__label">Agregar al carrito</p>
                        <p className="btn-cart__total">{totalPrice && `${currency === "USD" ? "U$S" : "$"} ${totalPrice}`}</p>
                        {/* <p className="btn-cart__total">{currency === "USD" ? "U$S" : "$"}{totalPrice}</p> */}
                    </span>

                    <svg className="btn-cart__icon" width="13" height="9" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.99992 0.333313L8.05992 1.27331L11.1133 4.33331H0.333252V5.66665H11.1133L8.05325 8.72665L8.99992 9.66665L13.6666 4.99998L8.99992 0.333313Z" fill={color === "white" ? "black" : "white"} />
                    </svg>
                </div>
            </button>
        )
    } else if (tag === "link-dropdown") {
        return (
            <Link className={`text-link primary-link-${color ? color : "black"} ${extraClass ? extraClass : ""} ${hasIcon ? "with-icon" : ""} link-dropdown`} to={`${url ? url : "#"}`} target={`${target ? target : "_self"}`} onClick={onClick ? onClick : null}>
                <span className="label">
                    {text}
                </span>

                {/* {hasIcon && (
                    <svg width="13" height="9" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.99992 0.333313L8.05992 1.27331L11.1133 4.33331H0.333252V5.66665H11.1133L8.05325 8.72665L8.99992 9.66665L13.6666 4.99998L8.99992 0.333313Z" fill="black" />
                    </svg>
                )} */}
                <svg width="13" height="9" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.99992 0.333313L8.05992 1.27331L11.1133 4.33331H0.333252V5.66665H11.1133L8.05325 8.72665L8.99992 9.66665L13.6666 4.99998L8.99992 0.333313Z" fill="black" />
                </svg>
            </Link>
        )
    } else if (tag === "toggle") {
        return (
            <button type={type ? type : "button"} className={`btn-${size ? size : "large"} btn-${btnStyle ? btnStyle : "primary"}-${color ? color : "black"} ${extraClass ? extraClass : ""} ${hasIcon ? "with-icon" : ""} ${disabled ? "--disabled" : ""}`} onClick={onClick ? onClick : null}>
                {text}
            </button>
        )
    } else {
        return (
            <a className={`btn-${size ? size : "large"} btn-${btnStyle ? btnStyle : "primary"}-${color ? color : "black"} ${extraClass ? extraClass : ""}`} href={`${url ? url : "#"}`} target={`${target ? target : "_self"}`} onClick={onClick ? onClick : null}>{text}</a>
        )
    }

}

export default Button